<div class="gt-routes-list-containerss">
  <div class="my-tasks-toolbar">
    <!-- Standalone row of its own, left-aligned, above the search/chips/toggle row below —
         moved to the top per user request rather than sharing a row right-aligned. -->
    <div *ngIf="toggleVisible" class="toolbar-row">
      <div class="toolbar-switch-container">
        <dx-button
          class="toggle-switch-option"
          [class.toggle-active]="tasklistViewState === TasklistViewState.MyTasks"
          i18n-text="@@tasklistToggleMyTasks"
          text="My tasks"
          (onClick)="onToggleMyTasks()"
        ></dx-button>
        <!-- the ReportsTo team scope ("Mein Team"), not the user's department -->
        <dx-button
          class="toggle-switch-option"
          [class.toggle-active]="tasklistViewState === TasklistViewState.DepartmentTasks"
          i18n-text="@@tasklistToggleTeamTasks"
          text="Team tasks"
          (onClick)="onToggleDepartmentTasks()"
        ></dx-button>
      </div>
    </div>

    <div class="toolbar-row">
      <div class="toolbar-search-container">
        <dx-text-box
          [showClearButton]="true"
          mode="search"
          [value]="searchExpr$ | async"
          (onValueChanged)="searchExpr$.next($event.value)"
          i18n-placeholder="@@userTaskSearch"
          placeholder="Search tasks..."
          valueChangeEvent="keyup"
          class="gt-text-box-style"
          style="border-radius: 8px"
        >
        </dx-text-box>
      </div>

      <div class="toolbar-filter-container">
        <dx-button
          class="filter-button"
          *ngFor="let data of filterButtonData"
          [template]="'buttonTemplate'"
          [class.filter-button-active]="data.id == activeStatusFilterId"
          (onClick)="toggleMyTasksFilter(data.id, data.statusFilterValue)"
        >
          <div class="status-button-template" *dxTemplate="let buttonData of 'buttonTemplate'">
            <div
              *ngIf="data.hasStatusDot"
              class="status-dot"
              [style.backgroundColor]="statusDotColors[data.statusId]"
            ></div>
            <span class="status-button-text"> {{ data.text }} </span>
            <div class="count-dot" [class.count-dot-active]="data.id == activeStatusFilterId">{{ data.count }}</div>
          </div>
        </dx-button>
      </div>

      <div *ngIf="tasklistViewState === TasklistViewState.DepartmentTasks" class="toolbar-export-container">
        <dx-drop-down-button
          i18n-text="@@exportsCaps"
          text="EXPORTS"
          icon="doc"
          displayExpr="name"
          class="gpd-input"
          [items]="downloadDocumentOptions"
          [width]="'max-content'"
          (onItemClick)="handleExportButtonClick($event)"
          [dropDownOptions]="{ width: '300px' }"
        ></dx-drop-down-button>
      </div>

      <div class="toolbar-active-tasks-container">
        <div i18n="@@currentTasks">Current Tasks</div>
        <dx-switch
          class="gt-switch"
          [(value)]="showCurrentTasksOnly"
          switchedOnText
          switchedOffText
          [width]="100"
          (onValueChanged)="toggleCurrentTasksFilter()"
        >
        </dx-switch>
      </div>
    </div>
  </div>

  <dx-data-grid
    #dataGrid
    [dataSource]="userTasks"
    (onInitialized)="onUserTaskGridInitialized($event)"
    (onRowClick)="onRowClick($event)"
    [allowColumnResizing]="true"
    [columnResizingMode]="'widget'"
    [columnAutoWidth]="false"
    [showColumnLines]="false"
    [showRowLines]="true"
    [showBorders]="true"
    [filterSyncEnabled]="true"
    [scrolling]="{ mode: 'virtual', useNative: true }"
    [width]="'100%'"
    [height]="'100%'"
    class="gt-data-grid-style"
    [hoverStateEnabled]="true"
    (onCellPrepared)="onCellPrepared($event)"
  >
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-paging [enabled]="false"></dxo-paging>

    <!--         <dxi-column dataField="taskNr" i18n-caption caption="Task Nr"></dxi-column> -->

    <dxi-column
      dataField="dateTime"
      i18n-captiondataType="date"
      format="dd.MM.yyyy"
      i18n-caption="@@dueDate"
      caption="Duedate"
      cellTemplate="dueDateTemplate"
    >
      <div class="due-date-template" *dxTemplate="let item of 'dueDateTemplate'">
        <div class="status-dot" [style.backgroundColor]="statusDotColors[item.data.groupId]"></div>
        <span class="gt-due-date-text">{{ item.data.dateTime | date: 'dd.MM.yyyy' }}</span>
      </div>
    </dxi-column>

    <dxi-column dataField="projectTitle" i18n-caption caption="Projekt Titel"></dxi-column>
    <dxi-column dataField="taskTitle" i18n-caption caption="Task Titel"></dxi-column>

    <dxi-column
      [visible]="tasklistViewState == 'DEPARTMENT_TASKS'"
      i18n-caption="@@responsibleUser"
      caption="Responsible User"
      dataField="holderName"
      cellTemplate="userMailCellTemplate"
    >
      <!-- #4994: a department-held task shows the department name with the group icon -->
      <div *dxTemplate="let item of 'userMailCellTemplate'" class="holder-cell">
        <app-svg-icon
          *ngIf="item.data.assignedDepartmentId != null"
          icon="user-multiple"
          [size]="18"
          color="var(--color-primary)"
        ></app-svg-icon>
        <span>{{ item.data.holderName }}</span>
      </div>
    </dxi-column>

    <dxi-column
      dataField="priority"
      i18n-caption
      caption="Priority"
      cellTemplate="priorityCellTemplate"
      alignment="left"
    >
      <dxo-header-filter [dataSource]="priorityHeaderFilter"> </dxo-header-filter>
      <div *dxTemplate="let item of 'priorityCellTemplate'">
        <app-priority-pill [editable]="true" [value]="item.data.priority"></app-priority-pill>
      </div>
    </dxi-column>

    <dxi-column [visible]="false" dataField="groupId"></dxi-column>
    <dxi-column [visible]="false" dataField="isMine" dataType="boolean"></dxi-column>
  </dx-data-grid>
</div>
